module.exports = __webpack_public_path__ + "static/microsoft-certified-devops-engineer-9ea5ba560dc0d1632b6de96d6fab03f9.png";